import {
  TopButtonBookingIcon,
  TopButtonOrderIcon,
  TopButtonReviewIcon,
  TopButtonBookmarkIcon,
  TopButtonCouponIcon,
} from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import { convertIntoDisplayCount } from '@web/libs/formatter'
import Clickable from '@web/ui/components/Clickable'

import styles from './ShortcutSection.module.scss'

export interface ShortcutSectionProps {
  onBookingClick?: () => void
  onOrderClick?: () => void
  onBookmarkClick?: () => void
  onCouponClick?: () => void
  onReviewClick?: () => void
  isDisplayBookmark?: boolean
  /**
   * 예약 개수
   */
  bookingCount: number
  /**
   * 주문 개수
   */
  orderCount: number
  /**
   * 쿠폰 개수
   */
  couponCount: number
  /**
   * 예약, 주문, 쿠폰 개수에 최대 노출할 개수 지정 이후 + 로 표시 e.g. 9 일때 초과 값은 "9+"
   */
  maxDisplayCount?: number
}

export default function ShortcutSection({
  onBookingClick,
  onCouponClick,
  onBookmarkClick,
  onOrderClick,
  onReviewClick,
  isDisplayBookmark = true,
  couponCount,
  bookingCount,
  orderCount,
  maxDisplayCount = 9,
}: ShortcutSectionProps) {
  return (
    <div className={styles.top_button_area}>
      <div className={styles.inner}>
        <Clickable className={styles.btn} onClick={onBookingClick} nClickCode={CLICK_CODE['my.shortcutbooking']}>
          <TopButtonBookingIcon className={styles.icon} aria-hidden="true" />
          예약
          {bookingCount > 0 && (
            <em className={styles.count}>{convertIntoDisplayCount({ count: bookingCount, maxDisplayCount })}</em>
          )}
        </Clickable>
        <Clickable className={styles.btn} onClick={onOrderClick} nClickCode={CLICK_CODE['my.shortcutorder']}>
          <TopButtonOrderIcon className={styles.icon} aria-hidden="true" />
          <span className={styles.name}>주문</span>
          {orderCount > 0 && (
            <em className={styles.count}>{convertIntoDisplayCount({ count: orderCount, maxDisplayCount })}</em>
          )}
        </Clickable>
        <Clickable className={styles.btn} onClick={onReviewClick} nClickCode={CLICK_CODE['my.shortcutreviewmy']}>
          <TopButtonReviewIcon className={styles.icon} aria-hidden="true" />내 리뷰
        </Clickable>
        {isDisplayBookmark && (
          <Clickable className={styles.btn} onClick={onBookmarkClick} nClickCode={CLICK_CODE['my.shortcutbookmark']}>
            <TopButtonBookmarkIcon className={styles.icon} aria-hidden="true" />
            저장
          </Clickable>
        )}
        <Clickable className={styles.btn} onClick={onCouponClick} nClickCode={CLICK_CODE['my.shortcutcoupon']}>
          <TopButtonCouponIcon className={styles.icon} aria-hidden="true" />
          쿠폰
          {couponCount > 0 && (
            <em className={styles.count}>{convertIntoDisplayCount({ count: couponCount, maxDisplayCount })}</em>
          )}
        </Clickable>
      </div>
    </div>
  )
}
